/// <reference path="../../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class ShowCartViewModel extends Tapas.ViewModels.CartViewModel {

        public OrderTemplateDataServive = new Ftw.Dataservice.OrderTemplateDataservice();
        public OrderTemplateSavedSweetAlert = ko.observable('');
        public OrderTemplateSaveAsListName = ko.observable('');
        public OrderTemplateShowFavListModalOpen = ko.observable(false);

        constructor() {
            super();

            // Here we listen to changes in the cartline when product is added
            // Next we update the cart
            this.Cart().CartLines.subscribe((changes) => {
                this.GetCurrentFromModule();
            }, null, "arrayChange");
        }
        public updateZip = (zip: string, city: KnockoutObservable<string>) => {
            return this.data.get("/Handlers/Firstweb.ERP.Users.ashx?cmd=getcity&zipcode=" + zip).then(function (response: IFirstWebERPService) {
                var ERPstatus = response.ERPStatus || null;
                console.log(response);

                if (ERPstatus) {
                    if (ERPstatus.Success) {
                        city(response.Data); // update City 

                    }
                    else {
                        this.logger.warning("Firstweb.ERP.Users failed with following error code: " + ERPstatus.Code);
                    }
                }
                else {
                    this.logger.warning("ERP status not found in Firstweb.ERP.Users.ashx");
                }
            });
        };
        public SaveCurrentCartAsOrderTemplate() {
            var cartObject = this.Cart();
            var lines: Array<Ftw.Dataservice.IOrderTemplateLine> = [];
            for (var i = 0; i < cartObject.CartLines().length; i++) {
                var line: Ftw.Interfaces.ICartLine = cartObject.CartLines()[i];
                var comment = line.CustomFields()[0].Value();

                if (!comment) {
                    comment = ""; 
                }

                var newLine: Ftw.Dataservice.IOrderTemplateLine = {
                    productId: line.ProductId(),
                    quantity: line.Quantity(),
                    comment: comment
                };
                lines.push(newLine);
            }
           
            if (this.OrderTemplateSaveAsListName()) {

                this.OrderTemplateDataServive.CreateNewOrderTemplate(this.OrderTemplateSaveAsListName(), lines).then((result) => {

                    this.OrderTemplateShowFavListModalOpen(false);
                }).finally(() => {

                });
            }
        }
    }
}

